import React, { FC } from 'react';
import { JobSearchHeroSection } from './JobSearchHeroSection';
import { JobListingsSection } from './JobListingsSection';
import { UserDashboardSection } from './UserDashboardSection';
import { CareerResourcesSection } from './CareerResourcesSection';

type Props = {
  title?: string;
};

export const HomePage: FC<Props> = (props) => {
  return (
    <div className={'!my-0'}>
      <JobSearchHeroSection />
      <JobListingsSection />
      <UserDashboardSection />
      <CareerResourcesSection />
    </div>
  );
};
